import moment from 'moment'
import { TIME_FORMAT } from 'config/consts'

const dateTimeFormatter = (date, format) => {
	const momentDate = moment(date).utc()
	const isTimeDate = date === new Date('1899-12-30').toISOString()
	// Return time only if date is DB date for storing time values
	const dateFormat = isTimeDate ? TIME_FORMAT : format
	return momentDate.isValid() ? momentDate.format(dateFormat) : null
}

export default dateTimeFormatter
